import React from "react";

import 'css/style.css';

import {ResultCollapsible} from 'components/lotto/utility/ResultCollapsible';
import AffiliateCta from 'affiliate/AffiliateCta';
import { AFFILIATE_MESSAGES } from 'affiliate/affiliateConfig';


export default function LottoResults({ data, isShowAtRender}) {

  //console.log("LottoResults:data = " + JSON.stringify(data))
  //console.log("LottoResults:results = " + JSON.stringify(results))

  let results = data.results;

  if (results?.data.length === 0 && results?.dreamList.length === 0){ 
        return (<div className="status-message status-error" role="alert">ไม่พบข้อมูล</div>);
  }
  else if (results?.data.length === 0  && results?.dreamList.length > 0){
      return (
          
        <div>
              <ResultCollapsible id="9" topic={"ความฝันที่เกี่ยวข้องกับ" + data.slug} table={results?.dreamList} slug={data.slug} isShowAtRender={isShowAtRender}/>
        </div>
      );
  }
  else{
        
        return (
        
        <div>
              
              <ResultCollapsible id="2" topic={"เลข " + data.slug + " : ประวัติการถูกรางวัล"} table={results?.keywordPrizeList} slug={data.slug} isShowAtRender={isShowAtRender}/>

              <ResultCollapsible id="9" topic={"เลข " + data.slug + " : ความฝันที่เกี่ยวข้อง"} table={results?.dreamList} slug={data.slug} isShowAtRender={isShowAtRender}/>

              <ResultCollapsible id="1" topic={"เลข " + data.slug + " : ถูกบ่อยแค่ไหน?"} table={results} slug={data.slug} isShowAtRender={isShowAtRender}/>

              <AffiliateCta variant="strip" message={AFFILIATE_MESSAGES.afterStats} />
        </div>
      );
  }
}